import React from 'react'

import classNames from 'classnames'

export interface CicloBonoFrame2Props extends React.PropsWithChildren<{}> {
  className?: string
  fullWidth?: boolean
  typeCard?: boolean
  img: string
  id?: string
}

const CicloBonoFrame2 = ({
  className,
  fullWidth,
  typeCard,
  children,
  img,
  id,
}: React.PropsWithChildren<CicloBonoFrame2Props>) => {
  const contactClassname = classNames(
    'flex',
    'flex-col-reverse',
    'md:flex-row',
    'justify-center',
    'items-center',
    'w-full',
    'space-x-0',
    'md:space-x-14',
    'space-y-6',
    'md:space-y-0',
    {
      'p-6': !fullWidth,
      'px-32': fullWidth,
      'w-screen': fullWidth,
      'rounded-xl': typeCard,
      'shadow-lg': typeCard,
    },
  )
  return (
    <div className={`${contactClassname} ${className}`} id={id}>
      <div
        className={`relative w-64 sm:h-80 sm:w-80 flex items-center justify-center`}
      >
        <img src={img} alt="image" style={{ objectFit: 'cover' }} />
      </div>
      {children}
    </div>
  )
}

export default CicloBonoFrame2
